import { AnyAction } from "redux";
import { TEMPLATE_CREATE_COMPLETED, TEMPLATE_CREATE_CONNECTED, TEMPLATE_CREATE_CONNECTING, TEMPLATE_CREATE_FAILED, TEMPLATE_CREATE_RESET, TEMPLATE_CREATE_STEP, TEMPLATE_CREATE_STEPS } from "../types";

type UiStatus = "Pending" | "In Progress" | "Completed" | "Failed";
const FROM_RAW: Record<string, UiStatus> = {
    pending: "Pending",
    in_progress: "In Progress",
    completed: "Completed",
    failed: "Failed",
};

interface TemplateState {
    isConnecting: boolean;
    connected: boolean;
    steps: { id: string; label: string; status: UiStatus; messages: string[] }[];
    complete: boolean;
    ok: boolean | null;
    summary: string | null
}
const initial: TemplateState = {
    isConnecting: false,
    connected: false,
    steps: [],
    complete: false,
    ok: null,
    summary: null

};

export function templateReducer(state = initial, action: AnyAction) {
    switch (action.type) {
        case TEMPLATE_CREATE_RESET:
            return initial;
        case TEMPLATE_CREATE_CONNECTING:
            return { ...state, isConnecting: true, connected: false };
        case TEMPLATE_CREATE_CONNECTED:
            return { ...state, isConnecting: false, connected: true };
        case TEMPLATE_CREATE_STEPS:
            return {
                ...state,
                steps: (action.payload?.steps || []).map((s: any) => ({
                    id: String(s.id),
                    label: s.name || s.label || `Step ${s.id}`,
                    status: FROM_RAW[s.status] || "Pending",
                    messages: [],
                })),
            };

        case TEMPLATE_CREATE_STEP: {
            // Backend sends {"step": {id, name, status}}
            const stepData = action.payload?.step || action.payload || {};
            const { id, status, message, name } = stepData;
            const stepId = String(id);
            const ui = FROM_RAW[status] || "Pending";
            const steps = [...state.steps];
            const i = steps.findIndex(s => s.id === stepId);
            if (i === -1) {
                steps.push({ id: stepId, label: name || stepId, status: ui, messages: message ? [message] : [] });
            } else {
                steps[i] = {
                    ...steps[i],
                    status: ui,
                    messages: message ? [...steps[i].messages, message] : steps[i].messages,
                };
            }
            return { ...state, steps };
        }

        case TEMPLATE_CREATE_COMPLETED:
            return {
                ...state,
                complete: true,
                ok: action.payload?.ok ?? true,
                summary: action.payload?.message || "Template created successfully",
              };
        case TEMPLATE_CREATE_FAILED:
            return {
                ...state,
                complete: true,
                steps: [],
                ok: false,
                summary: action.payload?.error || "Failed",
              };
        default:
            return state;
    }
}
